import { render } from "./BoardModalDelete.vue?vue&type=template&id=3d611631&scoped=true"
import script from "./BoardModalDelete.vue?vue&type=script&lang=js"
export * from "./BoardModalDelete.vue?vue&type=script&lang=js"

import "./BoardModalDelete.vue?vue&type=style&index=0&id=3d611631&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-3d611631"

export default script